/**
 * Copy + shape for the square image picker (settings/CompanyLogoField and its
 * mobile twin). Kept in its own dependency-free module because the mobile app
 * imports it: the web picker itself pulls react-easy-crop and lucide-react,
 * which the native bundle does not have.
 */
export const IMAGE_FIELD_COPY = {
  logo: {
    label: 'Logo',
    alt: 'Logo-ul companiei',
    upload: 'Încarcă logo',
    change: 'Schimbă logo-ul',
    hint: 'Se decupează pătrat și se redimensionează automat. Apare în meniul lateral pentru firma implicită.',
    cropTitle: 'Decupează logo-ul',
    use: 'Folosește logo-ul',
    shape: 'rounded-lg',
  },
  avatar: {
    label: 'Poza de profil',
    alt: 'Poza ta de profil',
    upload: 'Încarcă o poză',
    change: 'Schimbă poza',
    hint: 'Se decupează pătrat și se redimensionează automat. Apare lângă numele tău peste tot: sarcini, comentarii, chat, echipă.',
    cropTitle: 'Decupează poza',
    use: 'Folosește poza',
    shape: 'rounded-full',
  },
} as const;

export type ImageFieldKind = keyof typeof IMAGE_FIELD_COPY;
